'use strict';
const angular = require('angular');
import { extendedCRUDMethods } from "./extendedCRUDMethods";

export default function ServiceResource($resource) {
    'ngInject';
    return $resource('/api/services/:id', { id: '@id' }, extendedCRUDMethods);
}



// WEBPACK FOOTER //
// ./client/components/resources/service.resource.ts